'use strict';

function initFAQ() {
	$('.faqs-content a').click(function(e) {
		let headerHeight = $('.header--navigation').outerHeight();
		let targetPosition = $($(this).attr("href")).offset().top;

		window.scrollTo(window.scrollX, targetPosition - headerHeight);

		return false;
    });
}

export default { initFAQ };
